import React from 'react';

function formatJsonScalar(value: unknown): string {
  if (value === null) return 'null';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  return JSON.stringify(value);
}

const JsonAnswerView: React.FC<{ value: unknown }> = ({ value }) => {
  if (Array.isArray(value)) {
    return (
      <div className="space-y-3">
        {value.map((item, index) => (
          <div
            key={index}
            className="rounded-xl border border-solid border-[#dbe7f3] bg-[#f8fbff] px-4 py-3"
          >
            <JsonAnswerView value={item} />
          </div>
        ))}
      </div>
    );
  }

  if (value && typeof value === 'object') {
    return (
      <div className="space-y-2">
        {Object.entries(value).map(([key, fieldValue]) => (
          <div
            key={key}
            className="overflow-hidden rounded-lg border border-solid border-[#e5edf5] bg-white"
          >
            <div className="border-0 border-b border-solid border-[#eef3f8] bg-[#f7fafc] px-3 py-2 text-xs font-semibold text-[#5b6b7b]">
              {key}
            </div>
            <div className="px-3 py-2 text-sm leading-6 text-[#374151]">
              {fieldValue !== null && typeof fieldValue === 'object' ? (
                <JsonAnswerView value={fieldValue} />
              ) : (
                <div className="whitespace-pre-wrap break-words">
                  {formatJsonScalar(fieldValue)}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="whitespace-pre-wrap break-words text-sm leading-6 text-[#374151]">
      {formatJsonScalar(value)}
    </div>
  );
};

export default JsonAnswerView;
